import { trans } from "@mongez/localization";
import breadcrumbImage from "app/assets/images/about-us/breadcrumb.jpg";
import { pageHead } from "framework/config/meta";
import { Breadcrumbs } from "~/design-system/components/breadcrumbs";
import { AboutUsPage } from "~/modules/about-us/pages";
import { URLS } from "~/shared/urls";

export function meta() {
  return pageHead({
    title: trans("aboutUs"),
    description: trans("aboutUsPage.aboutUsDescription"),
  });
}

export default function AboutUs() {
  return (
    <>
      <Breadcrumbs
        image={breadcrumbImage}
        title="aboutUs"
        items={[{ text: "home", href: URLS.home }, { text: "aboutUs" }]}
      />
      <AboutUsPage />
    </>
  );
}
